module.exports = __webpack_public_path__ + "img/v.9fbbd799.png";